export const listToDict = list => {
  const dict = {}

  list.forEach((element) => dict[element.name] = element.value)

  return dict
}

export const stringToList = (value, separator) => {
  return value.split(separator)
}

export const formatCurrency = (value) => {
  const formatted = new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  }).format(value);
  
  return formatted
}

export const formatDateTime = (value) => {
  if (!value) return '';

  const date = new Date(value);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

// formatMonth(value)
// This function takes a date string (e.g. "2025-11-01") and returns the month's name in Spanish,
// with the first letter capitalized (e.g. "Noviembre").
// It uses Intl.DateTimeFormat to get the localized month name.
export const formatMonth = (value) => {
  const date = new Date(value);
  const month = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(date);
  return month.charAt(0).toUpperCase() + month.slice(1);
};
